import { BasePagination } from './hateoas/base-pagination';
import { CommandModel } from './command-model';
import { Link } from './hateoas/link';

export class CommandModelPaginated implements BasePagination {
  content: CommandModel[];
  links: Link[];
  page: any;

  constructor() {
    this.content = [];
    this.links = [];
    this.page = null;
  }
} 